import React from 'react';
import { Alert, Form, Select, Switch } from 'antd';
import { formatSchedoxOption, getSchedoxServiceItems } from '../../../utils/schedoxCatalog';

const SchedoxProductMappingFields = ({
  form,
  catalog,
  loading = false,
  allowLegacyUnmapped = false,
}) => {
  const syncEnabled = Form.useWatch('sync_to_schedox', form);
  const selectedServiceId = Form.useWatch('schedox_service_id', form);
  const services = catalog?.services || [];
  const items = getSchedoxServiceItems(catalog, selectedServiceId);

  const handleSyncChange = (enabled) => {
    if (!enabled) {
      form.setFieldsValue({
        schedox_service_id: null,
        schedox_service_item_id: null,
      });
    }
  };

  const handleServiceChange = (serviceId) => {
    form.setFieldsValue({
      schedox_service_id: serviceId,
      schedox_service_item_id: null,
    });
  };

  return (
    <>
      <Form.Item
        name="sync_to_schedox"
        label="Schedox integration"
        valuePropName="checked"
        className="col-span-2"
        extra="Create or update Schedox work only for this product on eligible Golden orders."
      >
        <Switch
          checkedChildren="Enabled"
          unCheckedChildren="Disabled"
          onChange={handleSyncChange}
        />
      </Form.Item>

      {syncEnabled ? (
        <>
          {services.length === 0 && !loading ? (
            <Alert
              className="col-span-2"
              type="warning"
              showIcon
              message="No active Schedox services are available yet."
            />
          ) : null}

          {allowLegacyUnmapped && !selectedServiceId ? (
            <Alert
              className="col-span-2"
              type="info"
              showIcon
              message="This existing product still uses the property/default Schedox service fallback."
            />
          ) : null}

          <Form.Item
            name="schedox_service_id"
            label="Pair with Schedox service"
            className="col-span-2 md:col-span-1"
            rules={[{
              required: !allowLegacyUnmapped,
              message: 'Select the Schedox service for this product.',
            }]}
            extra="Each Golden product can be paired with a different Schedox service."
          >
            <Select
              allowClear
              loading={loading}
              placeholder="Select a Schedox service"
              showSearch
              optionFilterProp="label"
              options={services.map((service) => ({
                value: Number(service.service_id),
                label: formatSchedoxOption(service),
              }))}
              onChange={handleServiceChange}
            />
          </Form.Item>

          <Form.Item
            name="schedox_service_item_id"
            label="Pair with service item (optional)"
            className="col-span-2 md:col-span-1"
            extra="Only items belonging to the selected service are shown."
          >
            <Select
              allowClear
              disabled={!selectedServiceId}
              loading={loading}
              placeholder={selectedServiceId ? 'Select an optional item' : 'Select a service first'}
              showSearch
              optionFilterProp="label"
              options={items.map((item) => ({
                value: Number(item.service_item_id),
                label: item.unit_price === null || item.unit_price === undefined
                  ? item.name
                  : `${item.name} - £${Number(item.unit_price).toFixed(2)}`,
              }))}
            />
          </Form.Item>
        </>
      ) : null}
    </>
  );
};

export default SchedoxProductMappingFields;
